<h2 class="bold">Retention</h2>
<fury-list>
    <div class="table table_container">
      <table mat-table [dataSource]="dataSource">
        <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
  
        <!-- agent Column -->
        <ng-container matColumnDef="agent">
          <th mat-header-cell *matHeaderCellDef>Created By</th>
          <td mat-cell *matCellDef="let element">
            {{ commonService.getFullName(element?.agentDetail?.firstName, element?.agentDetail?.lastName) }}
          </td>
        </ng-container>

         <!-- Assign User Column -->
         <ng-container matColumnDef="assignedUser">
          <th mat-header-cell *matHeaderCellDef>Assigned User</th>
          <td mat-cell *matCellDef="let element">
            {{ commonService.getFullName(element?.assignedUser?.firstName, element?.assignedUser?.lastName) }}
          </td>
        </ng-container>
  
        <!-- serviceAgreementNumber Column -->
        <ng-container matColumnDef="serviceAgreementNumber">
          <th mat-header-cell *matHeaderCellDef>Policy No.</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.agreementNumber }}
          </td>
        </ng-container>
  
        <!-- agreementStatus Column -->
        <ng-container matColumnDef="agreementStatus">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.status }}
          </td>
        </ng-container>
  
  
        <!-- createdOn Column -->
        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef>Creation Date</th>
          <td mat-cell *matCellDef="let element">{{ element?.agreementPurchaseDate| date : "MMM-dd-YYYY" }}</td>
        </ng-container>
  
  
        <!--  cancellationDate Column -->
        <ng-container matColumnDef="cancellationDate">
          <th mat-header-cell *matHeaderCellDef>Closed On</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.cancellationDate | date : "MMM-dd-YYYY" }}
          </td>
        </ng-container>

        <!-- Refund Column -->
        <ng-container matColumnDef="refund">
            <th mat-header-cell *matHeaderCellDef>Refund Amount </th>
            <td mat-cell *matCellDef="let element">
              {{ (element?.refund || 0) | currency }}
            </td>
          </ng-container>
  
    
        <ng-container matColumnDef="actions" stickyEnd>
          <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
          <td *matCellDef="let row; let i = index" class="actions-cell" mat-cell>
            <button
              type="button"
              mat-icon-button
              [matMenuTriggerFor]="actionsMenu"
              (click)="$event.stopPropagation()"
              *ngIf="row?.status === 'Pending Refund'"
            >
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
              <button mat-menu-item *ngIf="editorAccess && row?.status === 'Pending Refund'" (click)="handleCancelAgreement(row?.orderId)">
                <span>Initiate Refund</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess && row?.status === 'Pending Refund'" (click)="handleAssignAgreement(row)">
                <span>Assign Supervisor</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div
        *ngIf="!dataSource?.length"
        style="padding: 10px 0; text-align: center"
      >
        No data found.
      </div>
    </div>
  </fury-list>
  <mat-paginator
  *ngIf="this.totalCount > 0"
  [pageSizeOptions]="[5, 30, 50, 100, 9999]"
  [pageSize]="pageSize"
  [length]="totalCount"
  [pageIndex]="pageIndex"
  (page)="pageSizeChange($event)"
  showFirstLastButtons
  [selectConfig]="selectConfig"
  [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
  aria-label="Select page of periodic elements"
>
</mat-paginator>
  